import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {AngularTiptapEditorComponent, AteI18nService} from "@flogeez/angular-tiptap-editor";
import { NgClass } from "@angular/common";
import {FormsModule} from "@angular/forms";
import {PreloaderComponent} from "../../../../../shared/ui/preloader/preloader.component";
import {ConstantsService} from "../../../../../shared/services/constants.service";
import {EventsService} from "../../../../../shared/services/events.service";
import {LoadingService} from "../../../../../shared/services/loading.service";
import {tiptapEditorConfig, initTiptapI18n} from "../../../../../shared/helpers/helpers";

@Component({
  selector: 'app-close-test',
  templateUrl: './close-test.component.html',
  styleUrls: ['./close-test.component.scss'],
  standalone: true,
  imports: [
    AngularTiptapEditorComponent,
    PreloaderComponent,
    NgClass,
    FormsModule
]
})
export class CloseTestComponent implements OnInit {

  constantsService = inject(ConstantsService);
  eventsService = inject(EventsService);
  protected loadingService = inject(LoadingService)


  @Input() id = 0;
  @Input() maxId = 0;
  @Input() question = '';
  @Input() answers: any[] = [];
  @Input() EmptyQuestionList: any = [];
  @Input() ErrorText = false;


  @Output() OnAddVariant = new EventEmitter();
  @Output() OnChangeVariant = new EventEmitter();
  @Output() OnChangeQuestionText = new EventEmitter();
  @Output() OnDeleteQuestion = new EventEmitter();
  @Output() OnDeleteVariant = new EventEmitter();

  @Input() FileId = null;
  @Input() FileName: any = null;
  @Input() DownloadId: any = 0;

  @Output() OnUploadFile = new EventEmitter();
  @Output() OnDelete = new EventEmitter();
  @Output() OnDownload = new EventEmitter();

  maxVariantId = 0;
  editorConfig = tiptapEditorConfig;


  constructor(private i18n: AteI18nService) {
    initTiptapI18n(this.i18n);
  }

  onQuestionChange(content: string) {
    this.question = content;
    this.ChangeQuestionText();
  }

  ChangeQuestionText() {
    this.OnChangeQuestionText.emit(
      {
        id: this.id,
          question: this.question
      }
    )
  }

  DeleteTest() {
    this.OnDeleteQuestion.emit({id: this.id})
  }

  DeleteVariant(variantId: number) {
    this.OnDeleteVariant.emit(
      {
        id: this.id, variantId
      }
    )
  }

  AddVariant() {
    const id = this.maxId + 1;
    this.OnAddVariant.emit({
      id: this.id,
      variantId: id,
      right: this.answers.length < 1,
      error: false
    })

  }


  ChangeRightAnswer(item: any, event: any) {
    item['right'] = !item['right'];
    this.ChangeAnswers(item);
  }

  ChangeAnswers(item: any) {
    item['error'] = item['text'] === '';
    this.OnChangeVariant.emit({
      id: this.id,
      item
    })


  }

  DeleteFile() {
    this.OnDelete.emit();
  }

  UploadFile(files: any) {
    const file = files.files.item(0);
    let size: number = +(file['size'])
    if (size <= this.constantsService.FileMaxSize) {
      this.OnUploadFile.emit(file)
    } else {
      this.eventsService.throwError(`Размер файла не должен превышать ${this.constantsService.FileMaxSizeText}!`)
    }
  }

  DownloadFile() {
    this.OnDownload.emit({
      fileId: this.FileId,
      fileName: this.FileName
    });
  }

  ngOnInit(): void {
  }

}
